import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { EditableGridService, SystemApiService } from '@cv-invision/core';
import { DefaultSettingsModel } from '../model/xpanse-default-setting.model';

@Injectable({
	providedIn: 'root'
})
export class XpanseDefaultSettingService extends EditableGridService {
	private readonly BASE_URL = `${this.systemApiService.api.orders}/utils/xpanse/default-settings`;

	constructor(private httpClient: HttpClient, private systemApiService: SystemApiService) {
		super();
	}

	/**
	 * PUT - Save the configuration.
	 */
	saveXpanseDefaultSettings(config: DefaultSettingsModel): Observable<any> {
		return this.httpClient.put(this.BASE_URL, config);
	}

	/**
	 * GET - Return the list of the  Default Settings configuration mappings.
	 */
	getXpanseDefaultSettings(): Observable<any> {
		return this.httpClient.get(this.BASE_URL);
	}
}
